import { forwardRef } from 'react';

import { Modal, ModalHeaderProps } from '@mantine/core';

import classes from './Modal.module.css';

type ModalImageHeaderProps = Omit<ModalHeaderProps, 'style'> & {
  /**
   * Src for the background image
   */
  src?: string;
  aspectRatio?: number;
};

const _ModalImageHeader = forwardRef<HTMLDivElement, ModalImageHeaderProps>(
  ({ src, aspectRatio, children, ...props }, ref) => {
    return (
      <Modal.Header
        className={classes.header_image}
        style={{
          backgroundImage: `url(${src})`,
          aspectRatio: aspectRatio,
        }}
        {...props}
        ref={ref}
      >
        {children}
      </Modal.Header>
    );
  }
);
_ModalImageHeader.displayName = 'ModalImageHeader';

export const ModalImageHeader = _ModalImageHeader;
